
// Category
export const GET_STRELLATV_SUCCESS = 'GET_STRELLATV_SUCCESS';
export const GET_STRELLATV_FAIL = 'GET_STRELLATV_FAIL';